/*
Copyright (c) 2015, salesforce.com, inc. All rights reserved.
Copyright (c) 2019, Picsa Advisory Services (Pty) Ltd. All rights reserved.

Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
Neither the name of salesforce.com, inc. nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.

THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES LOSS OF USE, DATA, OR PROFITS OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
*/

import React from 'react'
import PropTypes from 'prop-types'

import {
  Heading
} from '../'

import {
  showAsCurrency
} from '../../utils'

export const Summary = ({ data, grandTotal, highLevelSummary }) => {
  let columns = data ? Object.keys(data) : []
  return (
    <React.Fragment>
      <Heading className='side-panel__title u-text-caps'>
        Summary
      </Heading>
      <div>
        {columns.map(column => (
          <div
            className={`${highLevelSummary ? 'slds-m-bottom_xx-small' : 'slds-m-bottom_large' }`}
            key={`summary_${column}`}>
            <table className='slds-max-medium-table_stacked-horizontal'>
              <thead
                className={`${highLevelSummary ? 'deduction-summary__section-heading no-border' : 'deduction-summary__section-heading'}`}>
                <SummaryHeaderRow
                  column={column}
                  count={data[column].count}
                  total={data[column].total}
                />
              </thead>
              {highLevelSummary
                ? <tbody></tbody>
                : <tbody>
                    {data[column].sub_items &&
                      <SummarySubItemRow
                        subItems={data[column].sub_items}
                      />
                    }
                  </tbody>
              }
            </table>
          </div>
        ))}
      </div>
      {grandTotal
        ? <div className='slds-clearfix deduction-summary__section-heading is-total'>
            <div className='slds-float_left'>
              TOTAL
            </div>
            <div className='slds-float_right'>
              {showAsCurrency('R', grandTotal)}
            </div>
          </div>
        : null
      }
    </React.Fragment>
  )
}

Summary.propTypes = {
  data: PropTypes.object.isRequired,
  grandTotal: PropTypes.string
}

const SummaryHeaderRow = ({ column, count, total }) => (
  <tr key={`summary_column_${column}`}>
    <td className='deduction-summary__td-type'>
      {column}
    </td>
    <td className='deduction-summary__td-type' style={{ textAlign: 'right' }}>
      {count}
    </td>
    <td className='deduction-summary__td-type' style={{ textAlign: 'right' }}>
      {total}
    </td>
  </tr>
)

const SummarySubItemRow = ({ subItems }) => {
  let rows = Object.entries(subItems)  // entries = array of [key, value] pairs
  return (
    <React.Fragment>
      {rows.map((row, index) => (
        <tr className='deduction-summary__line-item' key={`summary__${`${row[0]}_${index}`}`}>
          <td>
            {row[0]}
          </td>
          <td style={{ textAlign: 'right' }}>
            {row[1].count}
          </td>
          <td style={{ textAlign: 'right' }}>
            {row[1].total}
          </td>
        </tr>
      ))}
    </React.Fragment>
  )
}



// WEBPACK FOOTER //
// ./src/components/summary/index.js